import { defineMessages } from "react-intl";

const messages = defineMessages({
  createCopy: {
    id: "reports.exports.list.column.actions.createCopy",
    defaultMessage: "Create a copy",
    description: "Title of the Create copy export action",
  },
  deleteExport: {
    id: "reports.exports.list.column.actions.delete",
    defaultMessage: "Delete",
    description: "Title of the Delete export action",
  },
  deleteExportConfirm: {
    id: "reports.exports.list.column.actions.delete.confirm",
    defaultMessage: "Are you sure?",
    description: "Delete report confirmation text for a Delete export action",
  },
  deleteExportConfirmNo: {
    id: "reports.exports.list.column.actions.delete.confirm.no",
    defaultMessage: "No",
    description: "No-confirmation text for a Delete export report action",
  },
  deleteExportConfirmYes: {
    id: "reports.exports.list.column.actions.delete.confirm.yes",
    defaultMessage: "Delete",
    description: "Yes-confirmation text for a Delete export action",
  },
  downloadConfirmation: {
    id: "reports.exports.list.column.actions.editScheduleSend.limitConfirmation.title",
    defaultMessage:
      "This export exceeds the limit of {limit} records. If exported, the file will not be processed until 12:00 AM (Midnight) ET. <br></br><br></br>Apply filters to decrease the size of this export.",
    description: "Title for limit confirmation modal of report exporting list",
  },
  downloadConfirmationNo: {
    id: "reports.exports.list.column.actions.editScheduleSend.limitConfirmation.no",
    defaultMessage: "Wait",
    description: "No-confirmation text for limit confirmation modal of report exporting list",
  },
  downloadConfirmationYes: {
    id: "reports.exports.list.column.actions.editScheduleSend.limitConfirmation.yes",
    defaultMessage: "Export anyway",
    description: "Yes-confirmation text for limit confirmation modal of report exporting list",
  },
  quickSend: {
    id: "reports.exports.list.column.actions.quickSend",
    defaultMessage: "Quick send",
    description: "Title of the Quick send export action",
  },
  scheduleSend: {
    id: "reports.exports.list.column.actions.scheduleSend",
    defaultMessage: "Schedule send",
    description: "Title of the Schedule send export action",
  },
  scheduleSendFrequency: {
    id: "reports.exports.list.column.actions.scheduleSendFrequency",
    defaultMessage: "Edit schedule send",
    description: "Title of the Schedule send export with frequency action",
  },
});

export default messages;
